import keyBy from 'lodash/keyBy'

export function byID(array, field = '_sid') {
    return keyBy(array, field)
}
